if (window.location.hostname === 'www.vivagym.com') {
    console.log = function() {};
    console.error = function() {};
}